import React from 'react'

interface Props {
  condition: boolean
  children: React.ReactNode
  wrap: (children: React.ReactNode) => React.ReactElement
}

export const ConditionalWrap = ({ condition, children, wrap }: Props) =>
  condition ? React.cloneElement(wrap(children)) : children

export default ConditionalWrap
